import { generateClient, GraphQLResult, GraphQLSubscription } from 'aws-amplify/api';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { Observable } from 'zen-observable-ts';
import { IsLocalHost } from './helpers/isLocalHost';
import { captureSentry } from './helpers/sentryHelper';

const client = generateClient();

//NOTE: Je mets ça en false, en esperant que je me souviendrais de remettre en true avant de push x)
const shouldLogAPICalls = IsLocalHost();
const shouldLogSubscriptions = false;

export const callGraphQLApi = async <T extends GraphQLResult<any>>(
  query: string,
  variables: object
): Promise<T> => {
  const queryNameRegex = /(query|mutation|subscription)\s+(\w+)/;
  const queryName = query.match(queryNameRegex);

  if (shouldLogAPICalls) console.log(`callGraphQLApi | ${queryName}`);
  try {
    await getCurrentUser();

    const res = await client.graphql({
      query: query,
      variables: variables,
      authMode: 'userPool',
    });

    return res as T;
  } catch (_) {
    try {
      const authSession = await fetchAuthSession();
      // console.log('DEBUG >> callGraphQLApi | authSession', authSession);
      const res = await client.graphql({
        query,
        variables,
        authToken: authSession.credentials?.sessionToken,
      });
      return res as T;
    } catch (err) {
      captureSentry({
        title: 'callGraphQLApi failed',
        error: err,
        detail: {
          queryName,
          variables: JSON.stringify(variables),
        },
      });
      throw err;
    }
  }
};

export const graphqlSubscriber = async <T>(query: any, variables?: object) => {
  const queryNameRegex = /(query|mutation|subscription)\s+(\w+)/;
  const queryName = query.match(queryNameRegex);

  if (shouldLogSubscriptions) console.log(`graphqlSubscriber ${queryName}`);
  try {
    await getCurrentUser();
    const res = client.graphql({
      query,
      variables,
      authMode: 'userPool',
    });
    return res as GraphQLSubscription<any> as Observable<T>;
  } catch (_) {
    try {
      const authSession = await fetchAuthSession();
      const res = client.graphql({
        query,
        variables,
        authToken: authSession.credentials?.sessionToken,
      });

      return res as GraphQLSubscription<any> as Observable<T>;
    } catch (err) {
      captureSentry({
        title: 'graphqlSubscriber failed',
        error: err,
        detail: {
          queryName,
          variables: JSON.stringify(variables),
        },
      });
      throw err;
    }
  }
};
